export class BeneficiaryAddress{
  id: Number;
  name: String;
  firma: String;
  street: String;
  plz: String;
  town: String;
  country: String;
}
